import { Message } from '@alifd/next';

const MessageTip = {};
const config = {
  align: 'tc tc',
  offset: [0, 80],
  duration: 5000
};
const typeMap = {
  success: 'success',
  alert: 'warning',
  warning: 'warning',
  prompt: 'warning',
  error: 'error',
  help: 'help',
  loading: 'loading'
};

Object.keys(typeMap).forEach((type) => {
  MessageTip[type] = (content) => {
    Message[typeMap[type]]({
      ...config,
      content,
      prefix: 'im-next-'
    });
  };
});

MessageTip.show = (props) => {
  if (typeof props === 'string') {
    MessageTip.success(props);
    return;
  }
  Message.success({ ...props, prefix: 'im-next-' });
};

export default MessageTip;
